// Copyright 2017-2025 @polkadot/react-api authors & contributors
// SPDX-License-Identifier: Apache-2.0

class DunipodClientStateEmitter {
  private listeners = new Set<() => void>();

  addListener (callback: () => void) {
    this.listeners.add(callback);
  }

  removeListener (callback: () => void) {
    this.listeners.delete(callback);
  }

  emit () {
    this.listeners.forEach((callback) => callback());
  }
}

export const dunipodClientState = new DunipodClientStateEmitter();
